<template id="chapters-subject-page">
  <div class="is-100-vw">
    <!-- Dropdowns para seleccionar Curso y Asignatura -->
    <div class="container mt-4">
      <div class="columns">
        <div class="column is-6">
          <CursoDropdown 
            v-model="selectedCurso" 
            :mostrarErrores="mostrarErrores" 
            tooltip="Selecciona un curso" 
            @update:modelValue="onCursoChange"
          />
        </div>
        <div class="column is-6">
          <AsignaturaDropdown 
            v-model="selectedAsignatura" 
            :mostrarErrores="mostrarErrores" 
            tooltip="Selecciona una asignatura" 
            @update:modelValue="onAsignaturaChange"
          />
        </div>
      </div>
    </div>

    <br /><br />

    <div v-if="current_capitulo" class="container mt-4 is-bold ml-4 is-gapless has-text-success is-size-3 z-index-30 text-glow">
      {{ current_capitulo }}
    </div>

    <div v-if="subject" class="container ml-4 is-size-7 z-index-30">
      {{ subject.Cantidad_videos }} Videos || {{ orderedGroupedChapters.length }} unidades
    </div>

    <!-- Iterar sobre las unidades -->
    <div v-for="(unit, index) in orderedGroupedChapters" :key="unit.unidad" class="column is-12" style="z-index:30;">
      <div class="unit-border" style="z-index:30; position: relative">
        <div class="container ml-2 z-index-30">
          <span class="is-bold has-text-info is-size-5">{{ getUnidadLabel(index, unit.unidad) }}</span>
          <p class="has-text-grey is-size-7 z-index-30">
            {{ unit.grupos.length }} capítulos || 
            {{ unit.grupos.reduce((acc, curr) => acc + curr.capitulos.reduce((total, cap) => total + getVideosCap(cap.IdCapitulo).length, 0), 0) }} videos
          </p>
        </div>

        <!-- Iterar sobre los grupos de capítulos -->
        <div v-for="grupo in unit.grupos" :key="grupo.grupo" style="z-index:30;">
          <p class="container is-6 ml-3 mt-4" style="z-index:30;">
            <span class="has-text-grey is-bold is-size-6" style="z-index:30;">Capítulo: {{ grupo.grupo }}</span>
          </p>

          <div class="columns ml-4 is-mobile is-gapless columns-horizontal-scroll" style="overflow-x: auto; white-space: nowrap; z-index:30;">
            <div v-for="cap in grupo.capitulos" :key="cap.IdCapitulo" class="card video-card column is-12" style="display: inline-block; vertical-align: top; z-index:30;">
              <div class="columns is-mobile is-gapless" style="z-index: 999">
                <div class="column is-7">
                  <p class="subtitle is-7 ml-2 mt-4">
                    <span class="has-text-grey is-size-7">:: {{cap.Orden}} :: 
                      <br /> {{ cap.IdCapitulo }} - {{ cap.Glosa }}</span>
                  </p>
                </div>
              </div>
              <div class="columns is-mobile is-gapless video-carousel">
                <div v-for="(v, idx) in getVideosCap(cap.IdCapitulo)" :key="idx" class="column video-card-column">
                  <div>
                    - video_id: {{v.IdVideo}} |||
                    - vimeo id: {{v.VimeoId}}
                    <div class="card-image">
                      <figure class="image is-16by9">
                        <img :src="v.LinkImgPortada" alt="Video thumbnail" class="video-thumbnail" v-lazy="v.LinkImgPortada">
                      </figure>
                    </div>

                    <ButtonPrime 
                      label="Cargar Preguntas" 
                      icon="pi pi-image" 
                      class="p-button-success" 
                      @click="openQuestionModal(v)" 
                    />

                    <MatrixUploader
                        :id-curso="selectedCurso[0]"
                        :id-asignatura="selectedAsignatura[0]"
                        :id-unidad="mapUnidad(cap.UnidadGrupo)"
                        :id-capitulo="cap.IdCapitulo"
                        :id-video="v.IdVideo"
                        :usuario-id="user"
                        @matrix-loaded="handleMatrixLoaded"
                        @matrix-error="handleMatrixError"
                      />

                    <PreguntasPorUnidadYCapituloDialog
                      :id-eje-tematico="mapUnidad(cap.UnidadGrupo)"
                      :id-capitulo="cap.IdCapitulo"
                      :id-video="v.IdVideo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DialogPrime para carga masiva de preguntas -->
    <DialogPrime
      :visible="showQuestionModal"
      @update:visible="showQuestionModal = $event"
      header="Cargar Preguntas para Video"
      :modal="true"
      :style="{ width: '80vw' }"
    >
      <div class="p-d-flex p-flex-column p-ai-center">
        <h3 class="p-mb-3">{{ selectedVideo?.Glosa }}</h3>
        <div class="p-mb-4 upload-section">
          <label class="file-label p-d-inline-block p-p-3 p-text-center">
            <span>Seleccionar archivo Excel (.xlsx, .xls)</span>
            <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" class="file-input" />
          </label>
        </div>

        <div v-if="excelData.length" class="table-container p-w-100">
          <DataTablePrime 
            :value="excelData" 
            :paginator="true" 
            :rows="10" 
            :rowsPerPageOptions="[5, 10, 20]" 
            responsiveLayout="scroll"
            class="p-datatable-sm"
            dataKey="pregunta['N°_DE_PREGUNTA']"
          >
            <ColumnPrime header="Acción" headerStyle="width: 8rem">
              <template #body="slotProps">
                <ButtonPrime 
                  v-if="!isRowSelected(slotProps.data)" 
                  label="Agregar" 
                  icon="pi pi-plus" 
                  class="p-button-sm p-button-success" 
                  @click="addRow(slotProps.data)" 
                  :disabled="slotProps.data.status === 'Procesando' || isProcessing"
                />
                <ButtonPrime 
                  v-else 
                  label="Quitar" 
                  icon="pi pi-minus" 
                  class="p-button-sm p-button-danger" 
                  @click="removeRow(slotProps.data)" 
                  :disabled="slotProps.data.status === 'Procesando' || isProcessing"
                />
              </template>
            </ColumnPrime>

            <ColumnPrime header="N° DE PREGUNTA">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['N°_DE_PREGUNTA'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="PREGUNTA">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['PREGUNTA'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="ALTERNATIVAS">
              <template #body="slotProps">
                {{ slotProps.data.alternativas.map(a => `${a['NÚMERO_ALTERNATIVA']}: ${a['GLOSA']} (${a['CORRECTA'] ? 'Correcta' : 'Incorrecta'})`).join(', ') }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="GRADO DE DIFICULTAD">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['GRADO_DE_DIFICULTAD'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="HABILIDAD">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['HABILIDAD'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="UNIDAD">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['UNIDAD'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="SOLUCIÓN DESCRIPTIVA">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['SOLUCIÓN_DESCRIPTIVA'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="IMAGEN DE PREGUNTA">
              <template #body="slotProps">
                {{ slotProps.data.pregunta['IMAGEN_DE_PREGUNTA'] }}
              </template>
            </ColumnPrime>

            <ColumnPrime header="Estado">
              <template #body="slotProps">
                <span 
                  :class="getStatusClass(slotProps.data.status)" 
                  @click="handleStatusClick(slotProps.data)"
                  style="cursor: pointer;"
                >
                  {{ slotProps.data.status || 'Pendiente' }}
                  <i v-if="slotProps.data.status === 'Procesando'" class="pi pi-spin pi-spinner" style="margin-left: 5px;"></i>
                  <i v-else-if="slotProps.data.status === 'Éxito'" class="pi pi-check" style="margin-left: 5px;"></i>
                  <i v-else-if="slotProps.data.status && slotProps.data.status.startsWith('Error')" class="pi pi-times" style="margin-left: 5px;"></i>
                </span>
              </template>
            </ColumnPrime>
          </DataTablePrime>
        </div>
      </div>

      <template #footer>
        <div class="p-d-flex p-jc-end p-gap-2">
          <ButtonPrime 
            label="Agregar Todas" 
            icon="pi pi-plus-circle" 
            class="p-button-info" 
            @click="addAllRows" 
            :disabled="isProcessing || excelData.length === selectedRows.length"
          />
          <ButtonPrime 
            label="Eliminar Todas" 
            icon="pi pi-minus-circle" 
            class="p-button-warning" 
            @click="removeAllRows" 
            :disabled="isProcessing || !selectedRows.length"
          />
          <ButtonPrime 
            label="Cargar Preguntas" 
            icon="pi pi-check" 
            class="p-button-success" 
            @click="guardarPreguntas" 
            :disabled="!selectedRows.length || isProcessing" 
            :loading="isProcessing"
          />
          <ButtonPrime 
            label="Cancelar" 
            icon="pi pi-times" 
            class="p-button-secondary" 
            @click="closeQuestionModal" 
            :disabled="isProcessing"
          />
        </div>
      </template>
    </DialogPrime>

    <!-- Diálogo para mostrar el log -->
    <DialogPrime
      :visible="showLogModal"
      @update:visible="showLogModal = $event"
      header="Log de la Pregunta"
      :modal="true"
      :style="{ width: '50vw' }"
    >
      <div v-if="selectedQuestionLog" class="p-d-flex p-flex-column">
        <h4>Pregunta: {{ selectedQuestionLog.pregunta['PREGUNTA'] }}</h4>
        <p><strong>N° de Pregunta:</strong> {{ selectedQuestionLog.pregunta['N°_DE_PREGUNTA'] }}</p>
        <p><strong>Log:</strong></p>
        <pre>{{ selectedQuestionLog.log || 'No hay log disponible.' }}</pre>
      </div>
      <template #footer>
        <ButtonPrime 
          label="Cerrar" 
          icon="pi pi-times" 
          class="p-button-secondary" 
          @click="showLogModal = false"
        />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PreguntaService from '@/services/PreguntaService';
import SobjectService from '@/services/SobjectService';
import CursoDropdown from '@/components/selectores/CursoDropdown.vue';
import AsignaturaDropdown from '@/components/selectores/AsignaturaDropdown.vue';
import * as XLSX from 'xlsx';
import DialogPrime from 'primevue/dialog';
import DataTablePrime from 'primevue/datatable';
import ColumnPrime from 'primevue/column';
import ButtonPrime from 'primevue/button';
import PreguntasPorUnidadYCapituloDialog from '@/components/pregunta/PreguntasPorUnidadYCapituloDialog.vue';
import MatrixUploader from '@/components/pregunta/MatrixUploader';

export default {
  name: 'chapters-subject-page',
  components: {
    CursoDropdown,
    AsignaturaDropdown,
    DialogPrime,
    DataTablePrime,
    ColumnPrime,
    ButtonPrime,
    PreguntasPorUnidadYCapituloDialog, MatrixUploader
  },
  data() {
    return {
      showPreguntasDialog: false,
      selectedEjeTematico: 0,
      selectedCapitulo: 0,
      subject: null,
      chapters: [],
      isLoaded: false,
      orderedGroupedChapters: [],
      selectedCurso: [],
      selectedAsignatura: [],
      mostrarErrores: false,
      showQuestionModal: false,
      selectedVideo: null,
      excelData: [],
      tableHeaders: [
        'N°_DE_PREGUNTA', 'PREGUNTA', 'ALTERNATIVAS', 'GRADO_DE_DIFICULTAD', 'HABILIDAD', 'UNIDAD', 'SOLUCIÓN_DESCRIPTIVA', 'IMAGEN_DE_PREGUNTA'
      ],
      selectedRows: [],
      isProcessing: false,
      allSelected: false,
      showLogModal: false,
      selectedQuestionLog: null,
      device: {
        isMobile: false,
        isTablet: false,
        isTabletOnly: false,
        isDesktop: false,
        isDesktopOnly: false,
        isWidescreen: false,
        isWidescreenOnly: false,
        isFullhd: false,
      }
    };
  },
  methods: {
    openPreguntasDialog(cap) {
      this.selectedEjeTematico = this.mapUnidad(cap.UnidadGrupo);
      this.selectedCapitulo = cap.IdCapitulo;
      this.showPreguntasDialog = true;
    },
    getUnidadLabel(index, unidad) {
      let nuevaUnidad = unidad.replace(/^(I|II|III|IV|V|VI|VII|VIII|IX|X)\./, '').trim();
      if (nuevaUnidad.toLowerCase().startsWith('unidad')) {
        return `${nuevaUnidad}`;
      }
      return `Unidad ${index + 1}: ${nuevaUnidad}`;
    },
    getVideosCap(idd) {
      return this.subject?.VideosCapitulo.filter(x => x.IdCapitulo === idd) || [];
    },
    goVideo(video, capitulo) {
      console.log('Navegando a video:', video);
      capitulo.videos_capitulo__ = this.getVideosCap(capitulo.IdCapitulo);
      this.$store.dispatch('auth/set-current-capitulo', capitulo);
      this.$store.dispatch('auth/set-current-capitulo-id', capitulo.IdCapitulo);

      const vmi = video.VimeoId || 0;
      this.$router.push({
        name: 'watch-video',
        params: {
          video_glosa: video.Glosa,
          video_url: video.Link,
          video_id: video.IdVideo,
          video_poster: video.LinkImgPortada,
          vimeo_id: vmi,
          asignatura_id: this.selectedAsignatura[0],
          curso_id: this.selectedCurso[0]
        }
      });
    },
    getChapters(id_curso, id_asignatura) {
      console.log('Obteniendo capítulos para curso:', id_curso, 'y asignatura:', id_asignatura);
      this.$store.dispatch('form/submit', true);
      SobjectService.getDataSubjects(id_curso, id_asignatura)
        .then(response => {
          console.log('Respuesta de capítulos:', response.data);
          this.subject = response.data;
          const groupedByUnit = this.subject.Capitulos.reduce((units, chapter) => {
            const unitKey = chapter.UnidadGrupo;
            if (!units[unitKey]) units[unitKey] = {};
            const groupKey = chapter.GlosaGrupo;
            if (!units[unitKey][groupKey]) units[unitKey][groupKey] = [];
            units[unitKey][groupKey].push(chapter);
            return units;
          }, {});

          Object.keys(groupedByUnit).forEach(unitKey => {
            Object.keys(groupedByUnit[unitKey]).forEach(groupKey => {
              groupedByUnit[unitKey][groupKey].sort((a, b) => a.Orden - b.Orden);
            });
          });

          this.orderedGroupedChapters = Object.entries(groupedByUnit).map(([unidad, grupos]) => ({
            unidad,
            grupos: Object.entries(grupos).map(([grupo, capitulos]) => ({ grupo, capitulos }))
          }));
          console.log('Capítulos organizados:', this.orderedGroupedChapters);
          this.$store.dispatch('form/submit', false);
        })
        .catch(error => {
          console.error('Error al obtener los capítulos:', error);
          this.$store.dispatch('form/submit', false);
        });
    },
    onCursoChange(newValue) {
      console.log('Curso seleccionado:', newValue);
      this.selectedCurso = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
      }
    },
    onAsignaturaChange(newValue) {
      console.log('Asignatura seleccionada:', newValue);
      this.selectedAsignatura = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
      }
    },

    openQuestionModal(video) {
      console.log('Abriendo modal para video:', video);
      this.selectedVideo = video;
      this.showQuestionModal = true;
      this.excelData = [];
      this.selectedRows = [];
      this.isProcessing = false;

      const capitulo = this.subject.Capitulos.find(c => c.IdCapitulo === video.IdCapitulo);
      if (capitulo) {
        this.selectedUnidadId = capitulo.UnidadId || 0;
        console.log('Unidad seleccionada:', this.selectedUnidadId);
      } else {
        console.error('No se encontró el capítulo para el video:', video.IdCapitulo);
        this.selectedUnidadId = 0;
      }
    },
    closeQuestionModal() {
      console.log('Cerrando modal');
      this.showQuestionModal = false;
      this.selectedVideo = null;
      this.selectedRows = [];
      this.isProcessing = false;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        console.log('No se seleccionó ningún archivo');
        return;
      }

      console.log('Archivo seleccionado:', file.name);
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          console.log('Pestañas disponibles:', workbook.SheetNames);

          if (workbook.SheetNames.length < 2) {
            console.error('El archivo debe tener dos pestañas: preguntas y alternativas');
            alert('El archivo Excel debe tener dos pestañas: "preguntas" y "alternativas"');
            return;
          }

          const preguntasSheet = workbook.Sheets['preguntas'] || workbook.Sheets[workbook.SheetNames[0]];
          const preguntasDataRaw = XLSX.utils.sheet_to_json(preguntasSheet, { defval: '' });
          console.log('Datos de Preguntas (crudos):', preguntasDataRaw);

          const preguntasData = preguntasDataRaw.map(row => {
            const transformedRow = {};
            Object.keys(row).forEach(key => {
              const newKey = key.replace(/\s+/g, '_');
              transformedRow[newKey] = row[key];
            });
            return transformedRow;
          });
          console.log('Datos de Preguntas (transformados):', preguntasData);

          const alternativasSheet = workbook.Sheets['alternativas'] || workbook.Sheets[workbook.SheetNames[1]];
          const alternativasDataRaw = XLSX.utils.sheet_to_json(alternativasSheet, { defval: '' });
          console.log('Datos de Alternativas (crudos):', alternativasDataRaw);

          const alternativasData = alternativasDataRaw.map(row => {
            const transformedRow = {};
            Object.keys(row).forEach(key => {
              const newKey = key.replace(/\s+/g, '_');
              transformedRow[newKey] = row[key];
            });
            return transformedRow;
          });
          console.log('Datos de Alternativas (transformados):', alternativasData);

          this.excelData = preguntasData.map(pregunta => {
            const alternativas = alternativasData.filter(a => 
              a['N°_DE_PREGUNTA'] === pregunta['N°_DE_PREGUNTA']
            );
            return {
              pregunta,
              alternativas,
              status: 'Pendiente',
              log: ''
            };
          });
          console.log('Datos combinados:', this.excelData);

          if (this.excelData.length === 0 || this.excelData.some(row => row.alternativas.length === 0)) {
            console.error('Datos incompletos: faltan preguntas o alternativas');
            alert('El archivo Excel contiene datos incompletos. Asegúrate de que todas las preguntas tengan alternativas asociadas.');
            this.excelData = [];
          }
        } catch (error) {
          console.error('Error al procesar el archivo Excel:', error);
          alert('Error al procesar el archivo Excel: ' + error.message);
          this.excelData = [];
        }
      };
      reader.readAsArrayBuffer(file);
    },

    addRow(row) {
      if (!this.selectedRows.includes(row)) {
        this.selectedRows.push(row);
      }
    },

    removeRow(row) {
      this.selectedRows = this.selectedRows.filter(r => r !== row);
    },

    addAllRows() {
      this.selectedRows = this.excelData.filter(row => row.status !== 'Procesando' && row.status !== 'Éxito');
    },

    removeAllRows() {
      this.selectedRows = [];
    },

    isRowSelected(row) {
      return this.selectedRows.includes(row);
    },

    async guardarPreguntas() {
      if (!this.selectedRows.length) {
        alert('Por favor, selecciona al menos una pregunta para guardar.');
        return;
      }

      this.isProcessing = true;
      this.$store.dispatch('form/submit', true);
      const errores = [];

      try {
        if (!this.selectedUnidadId || this.selectedUnidadId === 0) {
          throw new Error('No se ha seleccionado una unidad válida para las preguntas.');
        }

        this.excelData = this.excelData.map(row => {
          if (this.selectedRows.includes(row)) {
            return { ...row, status: 'Procesando', log: `Procesando - ${new Date().toLocaleString()}` };
          }
          return row;
        });

        for (const row of this.selectedRows) {
          try {
            const alternativas = row.alternativas || [];
            const payload = {
              IdPregunta: row.pregunta['N°_DE_PREGUNTA'] || 0,
              Glosa: row.pregunta['PREGUNTA'] || '',
              Vigente: true,
              GlosaSolucion: row.pregunta['SOLUCIÓN_DESCRIPTIVA'] || '',
              LinkImagenPregunta: row.pregunta['IMAGEN_DE_PREGUNTA'] || '',
              LinkImagenSolucion: '',
              IdAsignatura: this.selectedAsignatura[0],
              IdCurso: this.selectedCurso[0],
              IdHabilidad: this.mapHabilidad(row.pregunta['HABILIDAD']),
              IdDificultad: this.mapDificultad(row.pregunta['GRADO_DE_DIFICULTAD']),
              IdModalidad: 1,
              IdEjeTematico: this.selectedUnidadId,
              IdVideo: this.selectedVideo.IdVideo,
              UsuarioIdCreacion: this.user,
              FechaCreacion: new Date().toISOString(),
              FechaActualizacion: new Date().toISOString(),
              IdOA: row.pregunta['OA'] || null,
              ConSonido: null,
              UrlSonido: '',
              VerGlosaPregunta: null,
              GlosaAlter1: alternativas[0]?.GLOSA || '',
              CFAlter1: alternativas[0]?.CORRECTA === 1,
              GlosaAlter2: alternativas[1]?.GLOSA || '',
              CFAlter2: alternativas[1]?.CORRECTA === 1,
              GlosaAlter3: alternativas[2]?.GLOSA || '',
              CFAlter3: alternativas[2]?.CORRECTA === 1,
              GlosaAlter4: alternativas[3]?.GLOSA || '',
              CFAlter4: alternativas[3]?.CORRECTA === 1
            };

            if (!payload.Glosa || (!payload.CFAlter1 && !payload.CFAlter2 && !payload.CFAlter3 && !payload.CFAlter4)) {
              throw new Error('Faltan campos obligatorios (pregunta o al menos una alternativa correcta)');
            }

            console.log('Enviando pregunta al backend:', payload);
            const response = await PreguntaService.saveQuestions(payload).catch(err => {
              throw new Error(`Fallo en el servidor: ${err.message}`);
            });

            const log = [
              `Pregunta guardada exitosamente.`,
              `ID Pregunta: ${payload.IdPregunta}`,
              `Fecha: ${new Date().toLocaleString()}`,
              `Usuario: ${this.user}`,
              `Video ID: ${this.selectedVideo.IdVideo}`,
              response.data?.message ? `Mensaje del servidor: ${response.data.message}` : ''
            ].filter(Boolean).join('\n');

            this.updateRowStatus(row, 'Éxito', log);
          } catch (error) {
            const errorMsg = error.response?.data?.message || error.message || 'Error desconocido al guardar la pregunta';
            console.error('Error al guardar pregunta:', errorMsg, error);
            errores.push({ ...row, error: errorMsg });
            const errorLog = [
              `Error al guardar la pregunta.`,
              `Mensaje: ${errorMsg}`,
              `Fecha: ${new Date().toLocaleString()}`,
              error.response?.status ? `Código HTTP: ${error.response.status}` : ''
            ].filter(Boolean).join('\n');
            this.updateRowStatus(row, `Error: ${errorMsg}`, errorLog);
          }
        }

        if (errores.length > 0) {
          console.warn('Se generaron errores durante el guardado:', errores);
          this.generarExcelErrores(errores);
          alert('Algunas preguntas no se pudieron guardar. Se ha generado un archivo con los errores.');
        } else {
          alert('Todas las preguntas seleccionadas fueron guardadas exitosamente.');
        }

        this.selectedRows = [];
      } catch (error) {
        console.error('Error crítico en el proceso de guardado:', error);
        alert('Error crítico al guardar las preguntas: ' + error.message);
        this.excelData = this.excelData.map(row => {
          if (row.status === 'Procesando') {
            return {
              ...row,
              status: 'Error: Proceso interrumpido',
              log: `${row.log}\nError crítico: ${error.message}\nFecha: ${new Date().toLocaleString()}`
            };
          }
          return row;
        });
      } finally {
        this.isProcessing = false;
        this.$store.dispatch('form/submit', false);
      }
    },

    updateRowStatus(row, status, log = '') {
      console.log('Actualizando estado de fila:', row.pregunta['N°_DE_PREGUNTA'], 'a', status);
      this.excelData = this.excelData.map(r => {
        if (r === row) {
          return { ...r, status, log: r.log + (r.log ? '\n' : '') + log };
        }
        return r;
      });
    },

    async handleStatusClick(row) {
      if (row.status === 'Éxito') {
        console.log('Abriendo log para pregunta:', row.pregunta['N°_DE_PREGUNTA']);
        this.selectedQuestionLog = row;
        this.showLogModal = true;
      } else if (row.status === 'Procesando') {
        console.log('Verificando estado de pregunta:', row.pregunta['N°_DE_PREGUNTA']);
        await this.checkProcessingStatus(row);
      }
    },

    async checkProcessingStatus(row) {
      try {
        // Aquí simulamos una verificación con el backend. Ajusta según tu API.
        const payload = {
          IdPregunta: row.pregunta['N°_DE_PREGUNTA'],
          IdVideo: this.selectedVideo.IdVideo
        };
        console.log('Verificando estado en el backend:', payload);
        // Suponiendo que tienes un endpoint para verificar el estado
        const response = await PreguntaService.checkQuestionStatus(payload).catch(() => {
          throw new Error('No se pudo verificar el estado');
        });

        const status = response.data?.status || 'Error: Estado no disponible';
        const log = [
          `Estado verificado manualmente.`,
          `Nuevo estado: ${status}`,
          `Fecha: ${new Date().toLocaleString()}`,
          response.data?.message ? `Mensaje del servidor: ${response.data.message}` : ''
        ].filter(Boolean).join('\n');

        this.updateRowStatus(row, status, log);
      } catch (error) {
        const errorMsg = error.message || 'Error al verificar el estado';
        console.error('Error al verificar estado:', errorMsg);
        const errorLog = `Error al verificar: ${errorMsg}\nFecha: ${new Date().toLocaleString()}`;
        this.updateRowStatus(row, `Error: ${errorMsg}`, errorLog);
      }
    },

    generarExcelErrores(errores) {
      const headers = [...this.tableHeaders, 'Error'];
      const data = [headers, ...errores.map(row => [
        row.pregunta['N°_DE_PREGUNTA'],
        row.pregunta['PREGUNTA'],
        row.alternativas.map(a => `${a['NÚMERO_ALTERNATIVA']}: ${a['GLOSA']} (${a['CORRECTA'] ? 'Correcta' : 'Incorrecta'})`).join(', '),
        row.pregunta['GRADO_DE_DIFICULTAD'],
        row.pregunta['HABILIDAD'],
        row.pregunta['UNIDAD'],
        row.pregunta['SOLUCIÓN_DESCRIPTIVA'],
        row.pregunta['IMAGEN_DE_PREGUNTA'],
        row.error
      ])];
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Errores");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Errores_Preguntas_${new Date().toISOString().split('T')[0]}.xlsx`;
      link.click();
      URL.revokeObjectURL(url);
    },

    getStatusClass(status) {
      if (status === 'Éxito') return 'status-success';
      if (status && status.startsWith('Error')) return 'status-error';
      if (status === 'Procesando') return 'status-processing';
      return 'status-pending';
    },

    mapHabilidad(habilidad) {
      const habilidades = {
        'Aplicar': 1,
        'Comprender': 2,
        'Analizar': 3,
        'Recordar': 4
      };
      return habilidades[habilidad] || 0;
    },

    mapDificultad(dificultad) {
      const dificultades = {
        'Fácil': 1,
        'Intermedio': 2,
        'Difícil': 3
      };
      return dificultades[dificultad] || 0;
    },

    mapUnidad(unidad) {
      if (!this.subject || !Array.isArray(this.subject.Capitulos)) {
        console.error('this.subject o Capitulos no están definidos');
        return 0;
      }

      const unidadNormalizada = unidad.replace('Unit', 'Unidad');
      const capituloEncontrado = this.subject.Capitulos.find(c => c.UnidadGrupo === unidadNormalizada);

      if (!capituloEncontrado) {
        console.error('No se encontró un capítulo con UnidadGrupo igual a', unidadNormalizada);
        return 0;
      }

      return capituloEncontrado.UnidadId || 0;
    }
  },
  created() {
    if (this.$route.params.curso_id && this.$route.params.asignatura_id) {
      console.log('Inicializando con parámetros de ruta:', this.$route.params);
      this.selectedCurso = [this.$route.params.curso_id];
      this.selectedAsignatura = [this.$route.params.asignatura_id];
      this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/access-token',
      current_capitulo: 'toolbar/title'
    })
  }
};
</script>

<style scoped>
.is-background { z-index: 1; }
.columns-horizontal-scroll { 
  display: flex; 
  overflow-x: auto; 
  white-space: nowrap; 
  padding: 10px 0; 
}
.columns-horizontal-scroll .column { 
  display: inline-block; 
  margin-right: 15px; 
}
.column { flex: 0 0 auto; }
.text-glow { 
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.9), 0 0 20px rgba(255, 255, 255, 0.8), 0 0 30px rgba(255, 255, 255, 0.7), 0 0 40px rgba(255, 255, 255, 0.6), 0 0 50px rgba(255, 255, 255, 0.5); 
}
.unit-border { 
  border: 0.1px solid #c0c0c0 !important; 
  border-radius: 8px !important; 
  padding: 16px; 
  margin-bottom: 12px !important; 
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important; 
  z-index: 30 !important; 
}

.video-carousel {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 15px;
  padding: 10px 0;
}

.video-card-column {
  flex: 0 0 auto;
  min-width: 200px;
  max-width: 250px;
}

.video-card {
  border: 2px solid #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.video-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.card-image {
  cursor: pointer;
}

.image.is-16by9 {
  padding-top: 56.25%;
  position: relative;
}

.video-thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.upload-section .file-label {
  background-color: #f5f5f5;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-section .file-label:hover {
  background-color: #e9ecef;
  border-color: #2196f3;
}

.file-input {
  display: none;
}

.table-container {
  width: 100%;
}

.status-success {
  color: #28a745;
  font-weight: 600;
}

.status-success:hover {
  text-decoration: underline;
}

.status-error {
  color: #dc3545;
  font-weight: 600;
}

.status-processing {
  color: #ffc107;
  font-weight: 600;
}

.status-processing .pi-spinner,
.status-success .pi-check,
.status-error .pi-times {
  font-size: 1rem;
  vertical-align: middle;
}

.status-pending {
  color: #6c757d;
}

.p-button-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
</style>